(function(){
    'use strict'

    angular.module('app.comprobantesPago')
    .factory('ComprobantesPagoService', ComprobantesPagoService);

    ComprobantesPagoService.$inject = ['$http', '$q', 'apiSettings', 'UserInfoService'];

    function ComprobantesPagoService($http, $q, apiSettings, UserInfoService) {

        var api = {
            getAll: getAll,
            generarComprobantes: generarComprobantes,
            generarComprobante: generarComprobante,
            generarTodosEnUnPDF: generarTodosEnUnPDF,
            generarComprobanteTest: generarComprobanteTest
        };

        return api;

        function getAll(searchCriteria){

            var response = $http({  
                url: apiSettings.apiBaseUrl + 'api/comprobantes-pago/search',  
                method: 'POST',  
                data: searchCriteria
            });  
            return response;
        };

        function generarComprobantes(searchCriteria){

            var response = $http({  
                url: apiSettings.apiBaseUrl + 'api/comprobantes-pago/generar-comprobantes',  
                method: 'POST',  
                data: searchCriteria
            });  
            return response;
        };

        function generarComprobante(searchCriteria){

            var response = $http({  
                url: apiSettings.apiBaseUrl + 'api/comprobantes-pago/generar-comprobante',  
                method: 'POST',  
                data: searchCriteria
            });  
            return response;
        };

        function generarComprobanteTest(searchCriteria){

            var response = $http({  
                url: apiSettings.apiBaseUrl + 'api/comprobantes-pago/generar-comprobante-test',  
                method: 'POST',  
                data: searchCriteria
            });  
            return response;
        };

        function generarTodosEnUnPDF(searchCriteria){

            var url = apiSettings.apiBaseUrl + 'api/comprobantes-pago/todos/' + UserInfoService.getCompaniaId() + '/' + searchCriteria.calendarizacionId;
            
            return $http.get(url, {
                responseType: 'arraybuffer'
            }).then(function (response) {
        
                var headers = response.headers();
                var fileName = headers['x-filename'];
                var contentType = headers['content-type'];

                var linkElement = document.createElement('a');
                try {
                    var blob = new Blob([response.data], { type: contentType });
                    var url = window.URL.createObjectURL(blob);
         
                    linkElement.setAttribute('href', url);
                    linkElement.setAttribute("download", fileName);
         
                    var clickEvent = new MouseEvent("click", {
                        "view": window,
                        "bubbles": true,
                        "cancelable": false
                    });
                    linkElement.dispatchEvent(clickEvent);
                } catch (ex) {
                    console.log(ex);
                }
            }).catch(function (data) {
                console.log(data);
            });
        };

    };

})();